import type { ReactNode } from 'react'

interface PaymentResultFrameProps {
    badge: string
    title: string
    subtitle: string
    children: ReactNode
    actions?: ReactNode
    className?: string
    badgeClassName?: string
    titleClassName?: string
    subtitleClassName?: string
    headerClassName?: string
}

export default function PaymentResultFrame({
    badge,
    title,
    subtitle,
    children,
    actions,
    className,
    badgeClassName,
    titleClassName,
    subtitleClassName,
    headerClassName,
}: PaymentResultFrameProps) {
    const shellClassName = ['pix-modal-content', className].filter(Boolean).join(' ')
    const headerClass = ['pix-modal-hero', headerClassName].filter(Boolean).join(' ')
    const badgeClass = ['pix-modal-badge', badgeClassName].filter(Boolean).join(' ')
    const shellTitleClass = ['pix-modal-title', titleClassName].filter(Boolean).join(' ')
    const shellSubtitleClass = ['pix-modal-subtitle', subtitleClassName].filter(Boolean).join(' ')

    return (
        <div className={shellClassName}>
            <div className={headerClass}>
                <div className={badgeClass}>{badge}</div>
                <div>
                    <h3 className={shellTitleClass}>{title}</h3>
                    <p className={shellSubtitleClass}>{subtitle}</p>
                </div>
            </div>

            {children}

            {actions && <div className="payment-result-actions">{actions}</div>}
        </div>
    )
}
